<template>
  <div>
    <div class="select">
      <h4 class="title1">
        <span>&nbsp;&nbsp;查询条件</span>
      </h4>
      <div class="selectColor">
        <div class="row">
          <el-row :gutter="15">
            <el-col :span="7">
              <el-row>
                <el-col :span="7">险种代码</el-col>
                <el-col :span="17">
                  <el-select multiple filterable v-model="riskCode" placeholder="请选择">
                    <!-- <el-option label="全部" :value="null">全部</el-option> -->
                    <el-option v-for="(item,index) in riskList" :key="index" :label="item.riskCode"
                               :value="item.riskCode"></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="7">
              <el-row>
                <el-col :span="7">险种名称</el-col>
                <el-col :span="17">
                  <el-input class="input" v-model="riskName" placeholder="请输入险种名称"></el-input>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="7">
              <el-row>
                <el-col :span="7">险种类别</el-col>
                <el-col :span="17">
                  <el-select v-model="riskType" placeholder="请选择">
                    <el-option label="全部" :value="null">全部</el-option>
                    <el-option label="普通产品销售资格" :value="'12'">普通产品销售资格</el-option>
                    <el-option label="分红产品销售资格" :value="'13'">分红产品销售资格</el-option>
                    <el-option label="特许产品销售资格" :value="'23'">特许产品销售资格</el-option>
                    <el-option label="专用产品销售资格" :value="'22'">专用产品销售资格</el-option>
                    <el-option label="标准产品销售资格" :value="'122'">标准产品销售资格</el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="7">
              <el-row>
                <el-col :span="7">主险/附加险</el-col>
                <el-col :span="17">
                  <el-select v-model="isMaster" placeholder="请选择">
                    <el-option label="全部" :value="null">全部</el-option>
                    <el-option label="主险" value="M">主险</el-option>
                    <el-option label="附险" value="A">附险</el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="7">
              <el-row>
                <el-col :span="7">上架状态</el-col>
                <el-col :span="17">
                  <el-select v-model="shelfState" placeholder="请选择">
                    <el-option label="全部" :value="null">全部</el-option>
                    <el-option label="待上架" value="0">待上架</el-option>
                    <el-option label="上架中" value="1">上架中</el-option>
                    <el-option label="上架完成" value="2">上架完成</el-option>
                    <el-option label="已下架" value="3">已下架</el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="7">
              <el-row>
                <el-col :span="7">在售状态</el-col>
                <el-col :span="17">
                  <el-select v-model="saleState" placeholder="请选择">
                    <el-option label="全部" :value="null">全部</el-option>
                    <el-option label="停售" value="0">停售</el-option>
                    <el-option label="在售" value="1">在售</el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="2" :offset="1">
              <el-button type="primary" @click="search()">筛选</el-button>
            </el-col>
          </el-row>
        </div>
        <!-- <div class="row">
            <el-row>
              <el-col :span="6">
                <el-row>
                  <el-col :span="4">
                    险种代码
                  </el-col>
                  <el-col :span="20"> <el-input class="input" v-model="riskCode" maxlength="6"></el-input> </el-col>
                </el-row>
              </el-col>
              <el-col :span="6">
                <el-row>
                  <el-col :span="4">
                    险种名称
                  </el-col>
                  <el-col :span="20"> <el-input class="input" v-model="riskName" maxlength="6"></el-input> </el-col>
                </el-row>
              </el-col>
              <el-col :span="6">
                <el-row>
                  <el-col :span="4">险种类别</el-col>
                  <el-col :span="20">
                    <el-select v-model="riskType" placeholder="请选择">
                      <el-option label="主险" value="M">主险</el-option>
                      <el-option label="附险" value="A">附险</el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="6">
                <el-row>
                  <el-col :span="6">主险/附加险</el-col>
                  <el-col :span="18">
                    <el-select v-model="zhu" placeholder="请选择">
                      <el-option label="全部" value="null">全部</el-option>
                      <el-option label="新人" value="0">新人</el-option>
                      <el-option label="地区" value="1">地区</el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-row>
                  <el-col :span="4">上架状态</el-col>
                  <el-col :span="20">
                    <el-select v-model="shelfState" placeholder="请选择">
                      <el-option label="待上架" value="0">待上架</el-option>
                      <el-option label="上架中" value="1">上架中</el-option>
                      <el-option label="上架完成" value="2">上架完成</el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="6">
                <el-row>
                  <el-col :span="4">在售状态</el-col>
                  <el-col :span="20">
                    <el-select v-model="saleState" placeholder="请选择">
                      <el-option label="在售" value="0">在售</el-option>
                      <el-option label="停售" value="1">停售</el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </el-col>

              <el-col :span="2" :offset="10">
                <el-button type="primary" @click="search()">筛选</el-button>
              </el-col>
            </el-row>
          </div> -->
      </div>
    </div>
    <div class="main">
      <h4 class="title1"><span>&nbsp;&nbsp;险种试卷列表</span></h4>
      <div>
        <el-table :data="list" style="width: 100%">
          <el-table-column type="index" label="编号" align="center" width="50"></el-table-column>
          <el-table-column prop="riskCode" label="险种代码" align="center"></el-table-column>

          <el-table-column prop="riskName" label="险种名称" align="center" v-if="T3"></el-table-column>

          <el-table-column prop="riskType" :formatter="formatterRiskType" label="险种类别" align="center"
                           v-if="T4"></el-table-column>

          <el-table-column :formatter="isMasterFilter" label="主/附险" align="center"></el-table-column>
          <el-table-column :formatter="shelfStateFilter" label="上架状态" align="center"></el-table-column>
          <el-table-column prop="shelfDate" label="上架时间" align="center"></el-table-column>
          <el-table-column :formatter="saleStateFilter" width="120" label="在售/停售状态"
                           align="center"></el-table-column>
          <el-table-column width="250" label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <el-button size="mini" v-if="scope.row.shelfState == '0'||scope.row.shelfState == '3'"
                         @click="handle(scope.row.id,'shelfState')">上架
              </el-button>
              <el-button size="mini" v-else @click="handle(scope.row.id,'shelfState')">下 架</el-button>
              <el-button size="mini" v-if="scope.row.saleState == 1 " @click="handle(scope.row.id,'saleState')">停 售
              </el-button>
              <el-button size="mini" v-else @click="handle(scope.row.id,'saleState')">起 售</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="modifyDate" label="修改时间" align="center"></el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          class="my-pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="req.startIndex"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          prev-click
          next-click
          :total="count"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/modules/api.js';
import url from '@/modules/url.js';
import {showFullScreenLoading, tryHideFullScreenLoading} from '@/components/utils/loading.js';

export default {
  data() {
    return {
      riskCode: '',
      riskName: '',
      riskType: null,
      saleState: null,
      shelfState: null,
      isMaster: null,
      riskList: [],
      count: 0,
      zhu: '',
      value: '',
      options: [{}],
      list: [],
      manageCom: [],
      manageCom1: [],
      req: {
        manageCom: '',
        examType: null,
        startDate: '',
        endDate: '',
        startIndex: 1,
        pageSize: 10,
        summaryType: 0
      },
      requestData: {
        riskCodes: null,
        riskName: null,
        riskType: null,
        shelfState: null,
        saleState: null,
        isMaster: null,
        pageSize: 10,
        currentPage: 1
      },
      T3: true,
      T4: true,
      total: 0,
      result: [],
      loadUrl: ''
    };
  },
  methods: {
    isMasterFilter(row, column) {
      return row.isMaster == 'M' ? '主险' : '附险';
    },
    saleStateFilter(row, column) {
      return row.saleState == 1 ? '在售' : '停售';
    },
    shelfStateFilter(row, column) {
      if (row.shelfState == 0) {
        return '待上架';
      } else if (row.shelfState == 1) {
        return '上架中';
      } else if (row.shelfState == 2) {
        return '上架完成';
      } else if (row.shelfState == 3) {
        return '已下架'
      }
    },
    formatterRiskType(row) {
      if (!row.riskType) {
        return '-'
      } else {
        if (row.riskType == 12) {
          return '普通产品销售资格'
        } else if (row.riskType == 13) {
          return '分红产品销售资格'
        } else if (row.riskType == 23) {
          return '特许产品销售资格'
        } else if (row.riskType == 22) {
          return '专用产品销售资格'
        } else if (row.riskType == 122) {
          return '标准产品销售资格'
        } else {
          return '-'
        }
      }
    },
    handle(id,handle) {
      // console.log('id', id);
      showFullScreenLoading();
      api.post(url.tabShelfState, {id,handle}, res => {
        tryHideFullScreenLoading();
        if (res.result.isSuccess === true) {
          this.getRiskList();
        } else {
          if (res.result.errors.length > 0) {
            this.$message(res.result.errors[0].errorCode + res.result.errors[0].error);
          } else {
            this.$message(res.result.error);
          }
        }
      });
    },
    reset() {
      // 重置
      this.manageCom = this.manageCom1;
      this.initDate();
      this.req.manageCom = this.manageCom;
      this.req.examType = null;
      this.req.startIndex = 1;
      this.req.pageSize = 10;
      this.req.summaryType = 0;
      this.search();
    },
    // summaryTypeChange(value) {
    //   if (value === 0) {
    //     this.T3 = false;
    //     this.T4 = false;
    //   }
    //   if (value === 1) {
    //     this.T3 = true;
    //     this.T4 = false;
    //   }
    //   if (value === 2) {
    //     this.T3 = true;
    //     this.T4 = true;
    //   }
    // },
    initManageCom() {
      let that = this;
      api.post(url.initAllManageCom, {}, function (res) {
        console.log('机构', res);
        that.options = JSON.stringify(res.data)
          .trim()
          .replace(/"children":\[\],/g, '');
        console.log(that.options);
        that.options = JSON.parse(that.options);
        // console.log(123,that.options[0].vale)
        that.manageCom = that.options[0].value;
        that.manageCom1 = that.options[0].value;
        that.req.manageCom = that.options[0].value;
        // that.search();
        // that.options.push({label: '全国', value: 'HO'})
      });
    },
    //查询
    search() {
      let that = this;
      this.requestData = {
        riskCodes: this.riskCode,
        riskName: this.riskName ? this.riskName : null,
        riskType: this.riskType,
        shelfState: this.shelfState,
        saleState: this.saleState,
        isMaster: this.isMaster,
        pageSize: 10,
        currentPage: 1
      }
      this.getRiskList()
      // this.requestData
    },
    // --------分页
    handleSizeChange(value) {
      this.req.pageSize = value;
      this.req.startIndex = 1;
      this.getRiskList();
    },
    handleCurrentChange(value) {
      this.requestData.currentPage = value
      // this.req.startIndex = value;
      this.getRiskList();
    },
    dateChange(value) {
      let startDate = new Date(value[0]);
      let endDate = new Date(value[1]);

      this.req.startDate = startDate.getTime();
      this.req.endDate = endDate.getTime();
    },
    //获取类型险种列表
    initRiskTypes() {
      let that = this
      api.post(url.initRiskTypes, {}, function (res) {
        if (res.result.isSuccess) {
          that.riskList = res.data
        } else {
          that.$message({});
        }
      });
    },
    getRiskList() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      api.post(url.getRiskList, this.requestData, res => {
        loading.close();
        if (res.result.isSuccess === true) {
          this.list = res.data.list;
          this.count = res.data.count;
        } else {
          if (res.result.errors.length > 0) {
            this.$message(res.result.errors[0].errorCode + res.result.errors[0].error);
          } else {
            this.$message(res.result.error);
          }
        }
      });
    }
  },
  watch: {
    manageCom(newValue, oldValue) {
      if (newValue.length === 1 && oldValue.length != 0) {
        this.req.manageCom = newValue[0];
      }
      if (newValue.length === 2 && oldValue.length != 0) {
        this.req.manageCom = newValue[1];
      }
      if (newValue.length === 3 && oldValue.length != 0) {
        this.req.manageCom = newValue[2];
      }
    },
    loadUrl(newValue, oldValue) {
      console.log(newValue);
      let a = document.createElement('a');
      a.style.display = 'none';
      a.href = newValue;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  },
  mounted() {
    this.getRiskList();
    this.initManageCom();
    this.initRiskTypes();
  }
};
</script>

<style scoped>
.title1 {
  background: #e0e0e0;
  height: 50px;
  line-height: 50px;
  margin: 0px 0px 0px 0px;
}

.selectColor {
  padding-bottom: 1px;
  /* width: 88%; */
}

.select >>> .el-col-6 {
  width: 24%;
}

/* .select >>> .el-input {
  width:
} */
.row {
  margin-top: 20px;
  padding-left: 20px;
  line-height: 50px;
}

.footer {
  padding: 10px 0 30px 0;
}

.right {
  margin: 5px 10px 0 0;
  float: right;
}

.my-pagination {
  float: right;
}

.maxWidth {
  width: 100%;
}

.el-select {
  width: 100%;
}

.selectColor >>> .el-input {
  width: 88%;
}

.select >>> .el-input {
  width: 100% !important;
}

.select >>> .el-row {
  margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/pages/exam/examManage/examOnlineMange.vue